import { render } from "./VerifyWithTokenView.vue?vue&type=template&id=3a361870"
import script from "./VerifyWithTokenView.vue?vue&type=script&lang=js"
export * from "./VerifyWithTokenView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__